import { render, staticRenderFns } from "./goodAdd.vue?vue&type=template&id=081bcf6c&scoped=true"
import script from "./goodAdd.vue?vue&type=script&lang=js"
export * from "./goodAdd.vue?vue&type=script&lang=js"
import style0 from "./goodAdd.vue?vue&type=style&index=0&id=081bcf6c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081bcf6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/deduct_saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('081bcf6c')) {
      api.createRecord('081bcf6c', component.options)
    } else {
      api.reload('081bcf6c', component.options)
    }
    module.hot.accept("./goodAdd.vue?vue&type=template&id=081bcf6c&scoped=true", function () {
      api.rerender('081bcf6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/good/goodAdd.vue"
export default component.exports